module.exports = __webpack_public_path__ + "img/pic4.17734022.png";